var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-upload',{attrs:{"action":_vm.url,"on-success":_vm.successHandle,"show-file-list":false}},[_vm._v(" "+_vm._s(_vm.value)+" "),_c('el-button',{attrs:{"size":"small","type":"primary"}},[_vm._v("点击上传")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }